export default function useFormIndex() {
    const componentId = document.getElementById('step::container')
        ?.getAttribute('wire:id');

    if (!componentId) {
        return null
    }

    return Livewire.find(componentId);
};
